"use client";

import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Single static news object (repeated for now)
const newsItem = {
  img: "/images/news/news1.png",
  topic: "Blog Topic",
  meta: "4 Min • August 19, 2022",
  title: "Lörem Ipsum Mönade",
};

// Repeat the same item N times (adjust length as needed)
const moreNews = Array.from({ length: 12 }, (_, i) => ({
  ...newsItem,
  id: i + 1,
  title: `${newsItem.title} #${i + 1}`,
}));

export const NewsPageComponent = () => {
  const trackRef = useRef(null);
  const firstCardRef = useRef(null);
  const [cardStep, setCardStep] = useState(0);

  // Measure one card width + gap so buttons scroll exactly one card
  useEffect(() => {
    const measure = () => {
      if (!firstCardRef.current || !trackRef.current) return;

      const card = firstCardRef.current;
      const rect = card.getBoundingClientRect();
      const trackStyles = window.getComputedStyle(trackRef.current);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || "0") || 0;

      setCardStep(rect.width + gap);
    };

    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const slideBy = (dir = 1) => {
    if (!trackRef.current || !cardStep) return;
    trackRef.current.scrollBy({ left: dir * cardStep, behavior: "smooth" });
  };

  return (
    <section id="news-page">
      <div className="new-page-inner one">
        <div className="container">
          <div className="row">
            <p className="f-w-400 l-h-1 font-barlow p-47 color-black">LAWS GOVERNING SURGICAL ASSISTANT PRACTICES</p>
            <br />
            <p>Detailed Explanation of S.B. 1264</p>
            <br />
            <h6>
              <a
                href="/upload/2022/10/Detailed-Explanation-of-S.B.-1264-by-Sen.-Hancock.pdf"
                className="font-barlow p-18 f-w-700"
                style={{ color: "#222222" }}
              >
                VIEW: DETAILED EXPLANATION OF S.B. 1264 BY SEN. HANCOCK{" "}
              </a>
            </h6>
            <br />
            <br />
            <div className="federal-act">
              <div className="flex center-center b-r-5 ">
                <a
                  href="https://www.cms.gov/nosurprises"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="t-t-u p-47 f-w-500 font-barlow"
                  style={{ color: "#222222" }}
                >
                  FEDERAL NO SURPRISES ACT - EXPLAINED BY CENTERS FOR MEDICARE IN DEPTH WITH SOLUTIONS FOR PATIENTS AND PROVIDERS
                </a>
              </div>
            </div>
          </div>
          <div className="content font-nunito-sans ">
            <div className="info flex top-left">
              <div className="left">
                <p className="p-18 f-w-500 font-nunito-sans">
                  It has long been a established fact that surgical assistants are under a tremendous financial pressure. Many has lost their jobs
                  because of poor reimbursements across board for all insurance carriers and specialties. Many established groups vanished one after
                  the other. Many providers took the route scrubbing as technicians which hospitals took advantage of. Contrary to the above-mentioned
                  facts, it is still possible to make a decent living by staying united under one umbrella and using a honest and dedicated billing
                  company. While industry struggles with the issue of Surgical Assistant billing,
                </p>
              </div>
              <div className="right flex flex-1">
                <p className="p-18 f-w-500 font-nunito-sans">
                  One such example is Universal Surgical Assistants with headquarters based in Houston, Texas. It has been established that there are
                  still insurance companies paying handsome which obviously cover the loses. If one follows the explanation of laws closely like here
                  below given in the document, it is very much possible to survive comfortably. Of course, it is not simply possible to work in the
                  operating room all day long and comply with all the administrative requirements of the industry. In such circumstances a group
                  setting works the best to manage the surgical assistant practices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="new-page-inner two">
        <div className="container">
          <div className="billing">
            <p className=" f-w-400 font-barlow t-t-u t-a-c p-47" style={{ color: "#45AFF1", lineHeight: "inherit" }}>
              The Surprise Billing Act has the potential to devastate the entire Surgical & Physician industry in U.S.
            </p>
          </div>
          <div className="content font-nunito-sans ">
            <div className="info flex top-left">
              <div className="left">
                <p style={{ color: "#fff" }} className="p-18 f-w-500 font-nunito-sans">
                  The act generally limits a patient's out-of-pocket costs for these services to what they would have had the services been provided
                  in-network. There is an exception for out-of-network providers delivering services at in-network facilities. Under the No Surprises
                  Act, plans and providers have 30 days to negotiate payment amounts. The act defers to states to set payment standards or dispute
                  resolution processes for fully insured plans. In determining the payment amount, the IDR (Independent Dispute resolution) entity
                  will consider the median in-network rate. In this process, each party submits a payment amount offer and supporting evidence, and
                  the certified IDR entities chooses one of the amounts. The losing party must also pay the arbitration costs.
                </p>
              </div>
              <div className="right flex flex-1">
                <p style={{ color: "#fff" }} className="p-18 f-w-500 font-nunito-sans">
                  An IDR entity will also consider information submitted by the parties, the provider’s training, education, experience, and quality.
                  The act provides for external reviews for any adverse determinations made under the surprise medical billing provisions of ERISA and
                  the PHSA. Other changes in the No Surprises Act include: Directing the secretaries of the U.S. Department of Labor, U.S. Department.
                  of Health and Human Services to issue regulations by January 1, 2022, on the provider nondiscrimination rules under the Affordable
                  Care Act. Establishing rules related to continuity of care to protect patients when provider relationships with a network are
                  terminated. The No Surprise Act of 2018 will take effect in 2022.
                </p>
              </div>
            </div>
          </div>
          {/* (your commented block left as-is) */}
        </div>
      </div>

      <div className="new-page-inner two" style={{ backgroundColor: "#F0F7FD" }}>
        <div className="container">
          <div className="billing">
            <p className=" f-w-400 font-barlow t-t-u t-a-c p-47" style={{ color: "#222222", lineHeight: "inherit" }}>
              The Surprise Billing Act has the potential to devastate the entire Surgical & Physician industry in U.S.
            </p>
          </div>
          <div className="content font-nunito-sans ">
            <div className="info flex top-left">
              <div className="left">
                <p style={{ color: "#222222" }} className="p-18 f-w-500 font-nunito-sans">
                  The act generally limits a patient's out-of-pocket costs for these services to what they would have had the services been provided
                  in-network. There is an exception for out-of-network providers delivering services at in-network facilities. Under the No Surprises
                  Act, plans and providers have 30 days to negotiate payment amounts. The act defers to states to set payment standards or dispute
                  resolution processes for fully insured plans. In determining the payment amount, the IDR (Independent Dispute resolution) entity
                  will consider the median in-network rate. In this process, each party submits a payment amount offer and supporting evidence, and
                  the certified IDR entities chooses one of the amounts. The losing party must also pay the arbitration costs.
                </p>
              </div>
              <div className="right flex flex-1">
                <p style={{ color: "#222222" }} className="p-18 f-w-500 font-nunito-sans">
                  An IDR entity will also consider information submitted by the parties, the provider’s training, education, experience, and quality.
                  The act provides for external reviews for any adverse determinations made under the surprise medical billing provisions of ERISA and
                  the PHSA. Other changes in the No Surprises Act include: Directing the secretaries of the U.S. Department of Labor, U.S. Department.
                  of Health and Human Services to issue regulations by January 1, 2022, on the provider nondiscrimination rules under the Affordable
                  Care Act. Establishing rules related to continuity of care to protect patients when provider relationships with a network are
                  terminated. The No Surprise Act of 2018 will take effect in 2022.
                </p>
              </div>
            </div>
          </div>
          {/* (your commented block left as-is) */}
        </div>
      </div>

      {/* ===== More News (exactly 3 visible, hidden scrollbar, prev/next) ===== */}
      <div className="new-page-inner two border">
        <div className="container">
          <div className="news-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
            <h1 className="p-47 f-w-400 font-barlow t-t-u">More News</h1>
            <div className="nav-buttons" style={{ display: "flex", gap: 8 }}>
              <button className="nav-btn" onClick={() => slideBy(-1)} aria-label="Previous" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "50%", border: "1px solid #ccc", background: "transparent", cursor: "pointer", color: "#fff", padding: 0 }}>
                <FaChevronLeft size={18} />
              </button>
              <button className="nav-btn" onClick={() => slideBy(1)} aria-label="Next" style={{ display: "flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: "50%", border: "1px solid #ccc", background: "transparent", cursor: "pointer", color: "#fff", padding: 0 }}>
                <FaChevronRight size={18} />
              </button>
            </div>
          </div>

          <div
            ref={trackRef}
            className="news-cards"
            style={{
              display: "flex",
              gap: 24,
              overflowX: "auto",
              scrollSnapType: "x mandatory",
              scrollBehavior: "smooth",
              paddingBottom: 8,
              scrollbarWidth: "none", // Firefox hide
              msOverflowStyle: "none", // IE/Edge hide
            }}
          >
            {/* Hide scrollbar (WebKit) */}
            {/* <style jsx>{`
              .news-cards::-webkit-scrollbar { display: none; }
              @media (max-width: 992px) {
                .news-card { flex: 0 0 calc((100% - 24px) / 2); }
              }
              @media (max-width: 600px) {
                .news-card { flex: 0 0 100%; }
              }
            `}</style> */}

            {moreNews.map((item, idx) => (
              <article key={item.id} ref={idx === 0 ? firstCardRef : null} className="news-card b-r-5">
                <div className="img">
                  <Image src={item.img} alt={item.title} width={640} height={360} style={{ width: "100%", height: "auto", display: "block" }} />
                </div>
                <div className="news-content" style={{ padding: 16 }}>
                  <p className="p-24 f-w-500 font-barlow color-black">{item.topic}</p>
                  <p className="p-18 f-w-500" style={{ color: "#9B9B9B" }}>
                    {item.meta}
                  </p>
                  <h3 className="p-32 f-w-500 font-barlow color-black" style={{ marginTop: 8 }}>
                    {item.title}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
